import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  isMobileApp = false;
  emailValue = '';
  isLoading = false;
  emailError = '';
  requestError = '';
  successMessage = '';

  constructor(
    private readonly appModeService: AppModeService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isMobileApp = this.appModeService.isApp();
  }

  clearEmail(): void {
    this.emailValue = '';
    this.emailError = '';
  }

  validateAndSubmit(): void {
    this.emailError = '';
    this.requestError = '';
    this.successMessage = '';

    const email = this.emailValue.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      this.emailError = 'FORGOT_PASSWORD.ERROR_INVALID_EMAIL';
      return;
    }

    this.isLoading = true;

    this.authService
      .forgotPassword(email)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          sessionStorage.setItem('pwResetEmail', email);
          this.successMessage = 'FORGOT_PASSWORD.SUCCESS_SENT';
          const lang = this.route.snapshot.paramMap.get('lang') || 'en';
          setTimeout(() => {
            // Placeholder: /:lang/verify-otp is not implemented yet.
            // Try navigating there first, then fallback to login to avoid dead-end UX.
            this.router.navigate([lang, 'verify-otp'], { state: { email } }).catch(() => {
              this.router.navigate([lang, 'login']);
            });
          }, 1500);
        },
        error: () => {
          this.requestError = 'FORGOT_PASSWORD.ERROR_SEND_FAILED';
        },
      });
  }

  navigateBack(): void {
    const lang = this.route.snapshot.paramMap.get('lang') || 'en';
    this.router.navigate([lang, 'login']);
  }
}
